const strings = {
  bestValue: "Best Value",
  subTitle: "Select your add-ons",
  title: "Enrich Your Rivals Experience"
};

export default strings;
